module.exports = __webpack_public_path__ + "static/media/stat-visitas.a21002a5.png";